import { post, get, update, deleteItem } from "./fetch";

export type COFFRET = {
  _id?: string | number;
  type?: string;
  emplacement?: string;
  faune?: string;
  espece?: string;
  genre?: string;
  sexe?: string;
  quantite?: number;
  dateCapture?: string;
  detailsCapture?: string;
  typeAchat?: string;
  prixAchat?: number;
  detailsAchat?: string;
  numeroCoffret?: string;
  numeroFacture?: string;
  numeroOrdre?: number;
  numero?: number;
  owner?: number;
  updatedAt?: Date;
  createdAt?: Date;
  cites?: string;
  factureFilename?: string;
};

enum CoffretPath {
  ALL_COFFRETS = "/coffret",
  ADD_COFFRET = "/coffret",
  UPDATE_COFFRET = "/coffret/",
  DELETE_COFFRET = "/coffret/",
}

export const allCoffrets = () => get(CoffretPath.ALL_COFFRETS);
export const addCoffret = (coffret: COFFRET) => post(coffret, CoffretPath.ADD_COFFRET);
export const updateCoffret = (coffret: COFFRET, id: number | string | undefined) =>
  update(coffret, CoffretPath.UPDATE_COFFRET + id);
export const deleteCoffret = (id: number | string) => deleteItem(CoffretPath.DELETE_COFFRET + id);

export const deleteTask = deleteCoffret;

/** ✅ Append 1 ligne dans la queue ETIQUETTES (Mongo côté serveur) */
export const appendEtiquetteRow = async (coffret: COFFRET) => {
  return post({ coffret }, "/coffret/etiquettes/append");
};

/** ✅ Reset queue */
export const resetEtiquettesCsv = async () => {
  return post({}, "/coffret/etiquettes/reset");
};

/** ✅ Télécharger ETIQUETTES.csv (généré au download) */
export const downloadEtiquettesCsv = async () => {
  const bust = Date.now();
  const token = localStorage.getItem("token") || "";

  const resp = await fetch(`/api/coffret/etiquettes/download?bust=${bust}`, {
    method: "GET",
    cache: "no-store",
    headers: {
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      Pragma: "no-cache",
      Accept: "text/csv",
    },
    credentials: "same-origin",
  });

  if (!resp.ok) {
    const txt = await resp.text().catch(() => "");
    throw new Error(`Download ETIQUETTES.csv impossible (${resp.status}) ${txt}`);
  }

  const blob = await resp.blob();

  if (!blob || blob.size === 0) {
    throw new Error("Download ETIQUETTES.csv vide (cache/304 ?) - réessaie.");
  }

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "ETIQUETTES.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
};

/** ✅ Compat: certains composants importent { exportCsvAll } */
export const exportCsvAll = downloadEtiquettesCsv;

/** ✅ Télécharger une facture PDF (accès réservé : le jeton de connexion est envoyé) */
export const downloadFacturePdf = async (filename: string) => {
  const clean = String(filename || "").trim();

  if (!clean) {
    throw new Error("Nom de facture vide");
  }

  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  const url = `/factures/${encodeURIComponent(clean)}?bust=${Date.now()}`;

  const resp = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "same-origin",
    cache: "no-store",
  });

  if (resp.status === 401) {
    throw new Error("Votre session a expiré. Reconnectez-vous pour télécharger la facture.");
  }
  if (resp.status === 404) {
    throw new Error("Aucune facture disponible pour ce spécimen.");
  }
  if (!resp.ok) {
    throw new Error("Impossible de télécharger la facture pour le moment.");
  }

  const blob = await resp.blob();
  const objectUrl = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = clean.toLowerCase().endsWith(".pdf") ? clean : `${clean}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
};